import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import ApiService from "../../services/apiService";
import Breadcrumbs from "../../coreComponents/breadcrumbs";

const CheckBoxs =  ({title,parentTitle,fields,onSubmit}:any)=>{

    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues:{
          PlotOnMap : false,
        },
    });
    const navigate = useNavigate();
    const[setIschecked,isChecked] = useState(false);

    const handleFormSubmit = async (data : any) =>{
         try{
      const formData = {...data}

      await onSubmit(formData)
    }catch(error:any){
      console.log(error);
    }
    }

    return(
        <>
          <Breadcrumbs mainTitle={title} parent={parentTitle} />
          <Col md="6" className="mx-auto">
           <Card className="p-5">
          <CommonCardHeader title={title} headClass="pb-3" />
            <Form className="theme-form" onSubmit={handleSubmit(handleFormSubmit)}>
              {fields.map((field:any)=>(
                <>
                 
            <Label className="col-form-label">{field.label}</Label>
              <input type=
                 {field.type}
                 className= {field.className}
                  accept=".kml"
                 checked = {field.type === "checbox"? undefined : undefined }
                 value={field.type !== 'checkbox'?'':undefined}
                 {...register(field.name, field.validation)}
                
               />
               </>
              ))}
                <div className="form-group mb-0">
              <div className="d-flex justify-content-between mt-3">
                <Button color="primary" type="submit">
                  Add {title}
                </Button>
                <Button color="danger" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                </div>
            </div>
            </Form>
          
             </Card>
          </Col>
        </>
    )
}
export default CheckBoxs;